import React, { useContext } from 'react';
import { HeaderContext } from '../../../../contexts/HeaderData/HeaderData';
import ExpressLogo from './ExpressLogo';


function ExpressLogoVM() {
  const { data } = useContext(HeaderContext);
  const headerProperty = data ? data.headerProperty : {};
  const logo = headerProperty.logoImage || '/content/dam/logos-fonts/logos/express/express-logo.svg';

  return <ExpressLogo logo={logo} />;
}

export default ExpressLogoVM;
